"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectionIsWithinLink = selectionIsWithinLink;
exports.getSelectedLink = getSelectedLink;
exports.getSelectedHref = getSelectedHref;
exports.convertRootRelLinkToAbsUrl = convertRootRelLinkToAbsUrl;
exports.convertSamePageLinkToAbsUrl = convertSamePageLinkToAbsUrl;
exports.convertPageRelLinkToAbsUrl = convertPageRelLinkToAbsUrl;
exports.getAbsoluteOrMailtoLink = getAbsoluteOrMailtoLink;
exports.getPreviewHref = getPreviewHref;
exports.insertOrEditLink = insertOrEditLink;
exports.adaptLinkPropsToAttr = exports.getLinkAttrProps = exports.removeUnInsertedLinks = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _hubl = require("rich-text-lib/utils/hubl");

var _dom = require("rich-text-lib/utils/dom");

var _url = require("./url");

var _hslink = require("../constants/hslink");

function selectionIsWithinLink(editor) {
  var selectedNode = editor.selection.getNode();

  if (!selectedNode) {
    return false;
  }

  var anchorNode = editor.dom.getParent(selectedNode, 'a', editor.getBody());
  return anchorNode && anchorNode.hasAttribute('href');
}

function getSelectedLink($selection) {
  return $selection.is('a') ? $selection : $selection.parents('a').first();
}

function getSelectedHref($selection) {
  var anchor = getSelectedLink($selection);
  return anchor.attr('href') || '';
}

function convertRootRelLinkToAbsUrl(editor, href) {
  if (!editor.settings.contentDomain) {
    return href;
  }

  var protocol = editor.settings.domainIsSsl ? 'https' : 'http';
  return protocol + "://" + editor.settings.contentDomain + href;
}

function convertSamePageLinkToAbsUrl(editor, href) {
  if (!editor.settings.absoluteUrl) {
    return href;
  }

  return "" + editor.settings.absoluteUrl + href;
}

function convertPageRelLinkToAbsUrl(editor, href) {
  if (!editor.settings.absoluteUrl) {
    return href;
  }

  return editor.settings.absoluteUrl + "/" + href;
}

function getAbsoluteOrMailtoLink(editor, href) {
  if ((0, _url.hasValidUrlScheme)(href) || (0, _hubl.hasHublVariable)(href) || href[0] === '#') {
    return href;
  } else if (href[0] === '/') {
    return convertRootRelLinkToAbsUrl(editor, href);
  }

  return convertPageRelLinkToAbsUrl(editor, href);
} // TODO: Can we support relative urls for pages that have NOT been published?


function getPreviewHref(editor, href) {
  if (href && href[0] === '#') return convertSamePageLinkToAbsUrl(editor, href);
  return href;
}

function insertOrEditLink(editor, savedLinkInfo) {
  var dom = editor.dom;
  var selectedNode = editor.selection.getNode();
  var parentAnchor = editor.dom.getParent(selectedNode, 'a');
  var linkText = savedLinkInfo.linkText,
      linkAttrs = (0, _objectWithoutProperties2.default)(savedLinkInfo, ["linkText"]);

  if (parentAnchor) {
    (0, _dom.restoreFocusAfter)(function () {
      // remove data-insert for cases where it is not removed prior to insert
      parentAnchor.removeAttribute('data-insert');
      dom.setAttribs(parentAnchor, linkAttrs);
      editor.undoManager.add();
    });
  } else {
    editor.undoManager.transact(function () {
      var finalLinkAttrs = (0, _extends2.default)({}, linkAttrs, {
        id: '__hsNewLink'
      });

      if (editor.selection.isCollapsed()) {
        var linkHTML = dom.createHTML('a', finalLinkAttrs, dom.encode(linkText));
        editor.insertContent(linkHTML);
      } else {
        editor.execCommand('mceInsertLink', false, finalLinkAttrs);
      } // Select the newly inserted link node


      var linkNode = editor.dom.get('__hsNewLink');
      editor.dom.setAttrib(linkNode, 'id', null);
      editor.selection.select(linkNode);
    });
  }
} // removes all links that were in the process of being inserted but didn't go through
// since formatter can't be used on an arbitrary selection but can be on an arbitrary node,
// this seems like the best solution to account for multi-node selection without changing the way formatter works


var removeUnInsertedLinks = function removeUnInsertedLinks(editor) {
  return function () {
    editor.$('a[data-insert="true"]').toArray().forEach(function (node) {
      if (node.getAttribute('href')) editor.dom.setAttrib(node, 'data-insert', null);else editor.formatter.remove('link', {}, node);
    });
  };
};

exports.removeUnInsertedLinks = removeUnInsertedLinks;

var getLinkAttrProps = function getLinkAttrProps(editor, selectedLink) {
  var href = selectedLink.attr('href') && getAbsoluteOrMailtoLink(editor, selectedLink.attr('href'));
  return {
    href: href,
    previewHref: getPreviewHref(editor, href),
    externalLink: selectedLink.attr('target') === '_blank',
    noFollow: !!selectedLink.attr('rel') && selectedLink.attr('rel').includes('nofollow')
  };
};

exports.getLinkAttrProps = getLinkAttrProps;

var adaptLinkPropsToAttr = function adaptLinkPropsToAttr(linkOptions) {
  var _ref;

  var href = linkOptions.href,
      noFollow = linkOptions.noFollow,
      externalLink = linkOptions.externalLink,
      linkText = linkOptions.linkText;
  return _ref = {}, (0, _defineProperty2.default)(_ref, _hslink.savedLinkFields.HREF, href), (0, _defineProperty2.default)(_ref, _hslink.savedLinkFields.REL, (noFollow ? _hslink.LINK_NOFOLLOW_KEY : '') + " noopener"), (0, _defineProperty2.default)(_ref, _hslink.savedLinkFields.TARGET, externalLink ? '_blank' : null), (0, _defineProperty2.default)(_ref, _hslink.savedLinkFields.TEXT, linkText), _ref;
};

exports.adaptLinkPropsToAttr = adaptLinkPropsToAttr;